module.exports = __webpack_public_path__ + "img/jenks-smc.ba27f9cf.jpg";